function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 2,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 6,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 10,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 14,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 4,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 8,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 12,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 16,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 2,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 6,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 10,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 14,
  width: 2,
  height: 2,
  fill: "#4F99C2"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 4,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 8,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 12,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 2,
  height: 2,
  fill: "#9BD6F7"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M5.8125 11.625H25.1875C25.3571 11.625 25.5251 11.6584 25.6818 11.7233C25.8385 11.7882 25.9809 11.8834 26.1008 12.0033C26.2208 12.1233 26.3159 12.2657 26.3808 12.4224C26.4458 12.5791 26.4792 12.747 26.4792 12.9167V23.8958C26.4792 24.2384 26.3431 24.5669 26.1008 24.8092C25.8586 25.0514 25.5301 25.1875 25.1875 25.1875H5.8125V28.4167C5.8125 28.5015 5.8292 28.5855 5.86166 28.6638C5.89412 28.7422 5.94169 28.8134 6.00166 28.8733C6.06163 28.9333 6.13283 28.9809 6.21118 29.0133C6.28954 29.0458 6.37352 29.0625 6.45833 29.0625H28.4167C28.588 29.0625 28.7522 28.9945 28.8733 28.8733C28.9945 28.7522 29.0625 28.588 29.0625 28.4167V9.34908L28.757 9.04167H24.9266C24.1394 9.04167 23.3844 8.72894 22.8277 8.17229C22.2711 7.61563 21.9583 6.86065 21.9583 6.07342V2.19971L21.6974 1.9375H6.45833C6.37352 1.9375 6.28954 1.9542 6.21118 1.98666C6.13283 2.01912 6.06163 2.06669 6.00166 2.12666C5.94169 2.18663 5.89412 2.25783 5.86166 2.33618C5.8292 2.41454 5.8125 2.49852 5.8125 2.58333V11.625ZM3.875 25.1875H1.29167C0.949095 25.1875 0.620555 25.0514 0.37832 24.8092C0.136086 24.5669 0 24.2384 0 23.8958L0 12.9167C0 12.747 0.0334099 12.5791 0.0983223 12.4224C0.163235 12.2657 0.258378 12.1233 0.37832 12.0033C0.498263 11.8834 0.640655 11.7882 0.797367 11.7233C0.954079 11.6584 1.12204 11.625 1.29167 11.625H3.875V2.58333C3.875 1.89819 4.14717 1.24111 4.63164 0.756641C5.11611 0.272172 5.77319 0 6.45833 0H22.5041L31 8.55083V28.4167C31 29.1018 30.7278 29.7589 30.2434 30.2434C29.7589 30.7278 29.1018 31 28.4167 31H6.45833C5.77319 31 5.11611 30.7278 4.63164 30.2434C4.14717 29.7589 3.875 29.1018 3.875 28.4167V25.1875Z",
  fill: "#4F99C2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5518 22H6.23926V21.0186L9.66211 16.1113H6.33203V14.8613H11.459V15.8379L8.04102 20.75H11.5518V22Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3604 22H12.1133V21.1406L12.9824 20.7402V16.1211L12.1133 15.7207V14.8613H15.3604V15.7207L14.4912 16.1211V20.7402L15.3604 21.1406V22Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0996 18.2207H18.5977C19.0632 18.2207 19.4115 18.1296 19.6426 17.9473C19.8737 17.7617 19.9893 17.4932 19.9893 17.1416C19.9893 16.7868 19.8916 16.5247 19.6963 16.3555C19.5042 16.1862 19.2015 16.1016 18.7881 16.1016H18.0996V18.2207ZM21.5176 17.0879C21.5176 17.8561 21.2767 18.4437 20.7949 18.8506C20.3164 19.2575 19.6344 19.4609 18.749 19.4609H18.0996V22H16.5859V14.8613H18.8662C19.7321 14.8613 20.3896 15.0485 20.8389 15.4229C21.2913 15.7939 21.5176 16.349 21.5176 17.0879Z",
  fill: "white"
});

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.99d9e142.svg";
export { ForwardRef as ReactComponent };